import React
	from 'react';
import {
	Button,
	ButtonGroup,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	Row
} from "reactstrap";
import classNames
	from "classnames";

import NotWonTable
	from "components/Tables/NotWonTable";

import PerfectScrollbar from 'perfect-scrollbar';
import {teamService} from "services/team.service";
import {chartService} from "../services";

var ps;

class RottingDeals extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			notWonAction: 7,
			TeamData: [],
			data: []
		}
		this.formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'AUD',
		});
		this.mainPanel = React.createRef();
	}

	componentDidMount() {
		// if(navigator.platform.indexOf('Win') > -1){
		// 	ps = new PerfectScrollbar(this.mainPanel);
		// }
		teamService.getAllTeams().then(resp => {
			this.setState({TeamData: resp})
		});
		chartService.getRottingDeals().then(resp => {
			this.setState({data: resp})
		})
	}

	getTotalValue = () => {
		var ret = 0;
		this.state.data.forEach(deal => {
			if (deal.DaysToSale >= this.state.notWonAction) {
				ret += deal.DealValue;
			}
		})
		return this.formatter.format(ret);
	}


	render() {
		return (
			<>
				<div
					className="content">
					<Row>
						<Col
							xs="12">
							<Card className="card-table">
								<CardHeader>
									<Row>
										<Col
											className="text-left"
											sm="6">
											<h5 className="card-category">&nbsp;</h5>
											<CardTitle
												tag="h2">{this.getTotalValue()}</CardTitle>
										</Col>
										<Col
											sm="6">
											<ButtonGroup
												className="btn-group-toggle float-right"
												data-toggle="buttons"
											>
												<Button
													tag="label"
													className={classNames("btn-simple", {
														active: this.state.notWonAction === 7
													})}
													color="info"
													id="0"
													size="sm"
													onClick={() => this.setState({notWonAction: 7})}
												>
													<input
														defaultChecked
														className="d-none"
														name="options"
														type="radio"
													/>
													<span
														className="d-none d-sm-block d-md-block d-lg-block d-xl-block">> 7
													</span>
													<span
														className="d-block d-sm-none">
														<i className="tim-icons icon-single-02"/>
													</span>
												</Button>
												<Button
													tag="label"
													className={classNames("btn-simple", {
														active: this.state.notWonAction === 14
													})}
													color="info"
													id="0"
													size="sm"
													onClick={() => this.setState({notWonAction: 14})}
												>
													<input
														defaultChecked
														className="d-none"
														name="options"
														type="radio"
													/>
													<span
														className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
														> 14
													</span>
													<span
														className="d-block d-sm-none">
														<i className="tim-icons icon-single-02"/>
													</span>
												</Button>
												<Button
													tag="label"
													className={classNames("btn-simple", {
														active: this.state.notWonAction === 30
													})}
													color="info"
													id="0"
													size="sm"
													onClick={() => this.setState({notWonAction: 30})}
												>
													<input
														defaultChecked
														className="d-none"
														name="options"
														type="radio"
													/>
													<span
														className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
														> 30
													</span>
													<span
														className="d-block d-sm-none">
														<i className="tim-icons icon-single-02"/>
													</span>
												</Button>
											</ButtonGroup>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<div
										className="" ref={this.mainPanel}>
										<NotWonTable
											view={this.state.notWonAction} data={this.state.data} reps={this.state.TeamData}/>
									</div>
								</CardBody>
							</Card>

						</Col>
					</Row>
				</div>
			</>
		)
	}
}

export default RottingDeals;